import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Grid, Button, IconButton, Typography, List, ListItem, ListItemText,Card,
  CardContent, Tabs, Tab, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from "react-i18next";

const TeamDetailsForm = ({ open, onClose, teamId, projectId, onTeamUpdate }) => {
    const [team, setTeam] = useState(null);
    const [tasks, setTasks] = useState([]);
    const [projectMembers, setProjectMembers] = useState([]);
    const [teamMembers, setTeamMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [currentTab, setCurrentTab] = useState(0);

    // Delete modal states
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [selectedManager, setSelectedManager] = useState('');
    const [teamManager, setTeamManager] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false); // Edit mod durumu

    const { t } = useTranslation();

    const api = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
    });

    const [tabValue, setTabValue] = useState(currentTab);

  const handleTabSwitch = (event, newValue) => {
    setTabValue(newValue);
    handleTabChange(event, newValue);
  };


    // Fetch team details
    useEffect(() => {
        if (teamId) {
            fetchTeamDetails();
            fetchTeamTasks();
            fetchProjectMembers();
            fetchTeamMembers();
            fetchUserRole()
        }
    }, [teamId]);

    const fetchTeamDetails = async () => {
        try {
            const response = await api.get(`/api/teams/${teamId}/details`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            setTeam(response.data);
            setName(response.data.name);
            console.log(response.data);
            setDescription(response.data.description);
            setTeamManager(response.data.manager);
            //setSelectedMembers(response.data.map(member => member.id));
        } catch (error) {
        }
    };

    const fetchTeamTasks = async () => {
        try {
            const response = await api.get(`/api/tasks/team/${teamId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            setTasks(response.data);
        } catch (error) {
        }
    };

    const fetchProjectMembers = async () => {
        try {
          const response = await api.get(`/api/projects/${projectId}/members`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });

            setProjectMembers(response.data);
        } catch (error) {
        }
    };

    const fetchTeamMembers = async () => {
        try {
            const response = await api.get(`/api/teams/${teamId}/members`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            setTeamMembers(response.data);
        } catch (error) {
        }
    };

    const handleSaveTeam = async () => {
        try {
            await api.patch(`/api/teams/${teamId}`, { name, description, projectId }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            if (onTeamUpdate) {
                onTeamUpdate(); // Takımların yeniden yüklenmesini sağla
            }
            toast.success(t("teamUpdated"));
            fetchTeamDetails(); // Update the team details
        } catch (error) {
          toast.error(t("teamUpdateFailed"));
        }
    };

    const handleAddMember = async () => {
        try {
            await api.post(`/api/projects/${projectId}/teams/${teamId}/members`, { userId: selectedMembers }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            toast.success(t("membersAdded"));
            fetchTeamMembers();
        } catch (error) {
          toast.error(t("membersAddFailed"));
        }
    };

    // Remove a member from the team
    const handleRemoveFromTeam = async () => {
        try {
            const token = localStorage.getItem('token');
            await api.delete(`/api/teams/${teamId}/members/${selectedMember.id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(t("memberRemoved", { name: selectedMember.name }));
            fetchTeamMembers(); // Update team members
            setShowDeleteModal(false);
        } catch (error) {
          toast.error(t("memberRemoveFailed"));
        }
    };

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const openDeleteModal = (member) => {
        setSelectedMember(member);
        setShowDeleteModal(true);
    };

    const fetchUserRole = async () => {
        try {
            const token = localStorage.getItem('token');
            // API isteğini yap
            const roleResponse = await api.get(`/api/projects/${projectId}/role`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log("rol " + roleResponse.data.roleId);
            if (roleResponse.data.roleId === 1) {
                setIsAuthorized(true);
            }
            else {
                setIsAuthorized(false);
            }
        } catch (error) {
        }
    };

    const handleAssignManager = async () => {
        try {
            const token = localStorage.getItem('token');
            await api.patch(`/api/teams/${teamId}/manager`, { managerId: selectedManager, projectId: projectId }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(t("managerAssigned"));
            fetchTeamDetails(); // Update team details to reflect the new manager
        } catch (error) {
            
          toast.error(t("managerAssignFailed"));
        }
    };


    return (
<Modal open={open} onClose={onClose}>
  <Box
    sx={{
      padding: 4,
      backgroundColor: "white",
      width: { xs: "95vw", sm: "80vw", md: "70vw" },
      height: "85vh",
      margin: "5% auto",
      borderRadius: 3,
      boxShadow: 6,
      overflowY: "auto",
    }}
  >
    <ToastContainer />

    <Typography variant="h4" color="primary" fontWeight="bold" mb={3} textAlign="center">
      {team ? `${t("team")}: ${team.name}` : t("teamDetails")}
    </Typography>

    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
      <Tabs value={tabValue} onChange={handleTabSwitch} centered>
        <Tab label={t("teamDetailsTab")} value={0} />
        <Tab label={t("assignedTasks")} value={1} />
        <Tab label={t("members")} value={2} />
      </Tabs>
    </Box>

    {/* Team Details Tab */}
    {tabValue === 0 && (
      <Card elevation={3} sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{t("teamInfo")}</Typography>
            {isAuthorized && (
              <IconButton onClick={() => setIsEditMode(!isEditMode)}>
                <EditIcon color="action" />
              </IconButton>
            )}
          </Box>

          {isEditMode ? (
            <>
              <TextField label={t("teamName")} value={name} onChange={(e) => setName(e.target.value)} fullWidth margin="normal" />
              <TextField label={t("description")} value={description} onChange={(e) => setDescription(e.target.value)} multiline rows={3} fullWidth margin="normal" />
              <Button variant="contained" color="primary" onClick={handleSaveTeam} fullWidth sx={{ mt: 2 }}>
                {t("saveChanges")}
              </Button>
            </>
          ) : (
            <>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                {t("teamName")}: {name}
              </Typography>
              <Typography variant="body1" mb={1}>
                {t("description")}: {description || t("noDescription")}
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {teamManager ? `${t("teamManager")}: ${teamManager.name}` : t("noTeamManager")}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    )}

    {/* Assigned Tasks Tab */}
    {tabValue === 1 && (
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            {t("assignedTasks")}
          </Typography>
          <List>
            {tasks.length > 0 ? (
              tasks.map((task) => (
                <ListItem key={task.id}>
                  <ListItemText primary={task.title} secondary={`${t("dueDate")}: ${task.due_date} | ${t("status")}: ${task.status}`} />
                </ListItem>
              ))
            ) : (
              <Typography color="textSecondary">{t("noTasks")}</Typography>
            )}
          </List>
        </CardContent>
      </Card>
    )}

    {/* Members Tab */}
    {tabValue === 2 && (
      <Card elevation={3} sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            {t("currentTeamMembers")}
          </Typography>
          <List sx={{ maxHeight: 250, overflowY: "auto", mb: 3 }}>
            {teamMembers.length > 0 ? (
              teamMembers.map((member) => (
                <ListItem key={member.id} secondaryAction={isAuthorized && <IconButton edge="end" onClick={() => openDeleteModal(member)}><DeleteIcon color="error" /></IconButton>}>
                  <ListItemText primary={member.name} secondary={member.email} />
                </ListItem>
              ))
            ) : (
              <Typography color="textSecondary">{t("noMembers")}</Typography>
            )}
          </List>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                {t("assignTeamManager")}
              </Typography>
              <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
                <InputLabel>{t("selectManager")}</InputLabel>
                <Select label={t("selectManager")} value={teamManager ? teamManager.id : ""} onChange={(e) => setSelectedManager(e.target.value)}>
                  {teamMembers.map((member) => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.name} ({member.email})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button variant="contained" color="primary" onClick={handleAssignManager} fullWidth>
                {t("assignManager")}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
  <Typography variant="h6" gutterBottom>
    {t("addMembersToTeam")}
  </Typography>
  <FormControl fullWidth variant="outlined">
    <InputLabel>{t("selectProjectMembers")}</InputLabel>
    <Select
      multiple
      value={selectedMembers}
      label={t("selectProjectMembers")}
      onChange={(e) => setSelectedMembers(e.target.value)}
      renderValue={(selected) =>
        selected
          .map((id) => {
            const user = projectMembers.find((member) => member.id === id);
            return user ? user.name : "";
          })
          .join(", ")
      }
    >
      {projectMembers.filter(
        (member) => !teamMembers.some((teamMember) => teamMember.id === member.id)
      ).length > 0 ? (
        projectMembers
          .filter((member) => !teamMembers.some((teamMember) => teamMember.id === member.id))
          .map((member) => (
            <MenuItem key={member.id} value={member.id}>
              {member.name} ({member.email})
            </MenuItem>
          ))
      ) : (
        <MenuItem disabled>{t("allMembersAlreadyAdded")}</MenuItem>
      )}
    </Select>
  </FormControl>
  <Button
    variant="contained"
    color="primary"
    onClick={handleAddMember}
    fullWidth
    sx={{ mt: 2 }}
    disabled={
      projectMembers.filter((member) => !teamMembers.some((teamMember) => teamMember.id === member.id))
        .length === 0
    }
  >
    {t("addSelectedMembers")}
  </Button>
</Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* Delete Member Modal */}
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
  <Box
    sx={{
      backgroundColor: "white",
      padding: 4,
      margin: "15% auto",
      width: { xs: "90vw", sm: "400px" },
      borderRadius: 3,
      boxShadow: 6,
      textAlign: "center",
    }}
  >
    <Typography variant="h5" gutterBottom>
      {t("confirmDeletion")}
    </Typography>
    <Typography variant="body1" mb={2}>
      {t("confirmRemoveMember", { name: selectedMember?.name })}
    </Typography>
    <Button
      onClick={handleRemoveFromTeam}
      variant="contained"
      color="error"
      fullWidth
      sx={{ mb: 2 }}
    >
      {t("delete")}
    </Button>
    <Button
      onClick={() => setShowDeleteModal(false)}
      variant="outlined"
      color="primary"
      fullWidth
    >
      {t("cancel")}
    </Button>
  </Box>
</Modal>
    </Box>
  </Modal>
    );
};

export default TeamDetailsForm;
